export const ScenarioDetailData = {
  fields: [
    {
      key: "year",
      label: "Anno",
      sortable: false,
      class: "table-data-year"
    },
    {
      key: "contracValue",
      label: "Valore del contratto",
      sortable: false,
      class: "table-data-25"
    },
    {
      key: "deadValue",
      label: "Capitale in caso di decesso",
      sortable: false,
      class: "table-data-25"
    },
    {
      key: "rescureValue",
      label: "Il tuo capitale",
      sortable: false,
      class: "table-data-25"
    }
  ],
  data: []
};
